import React from "react";
import PropTypes from "prop-types";
import "./ImageElement.css";
import ItemTypes from "../../../../../../constants/ItemTypes";
import { DragSource } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";
import ImageElement from "../ImageElement";

const source = {
  beginDrag(props) {
    // Return the data describing the dragged item
    const isDragging = true,
      isSelected = props.imageElement.is_selected;

    props.handleIsDragging(isDragging, isSelected);

    const item = calculatePosition(props);
    item.element = props.imageElement;
    item.type = ItemTypes.IMAGE;
    item.index = props.index;
    item.layerId = props.layerId;
    item.isSelected = props.imageElement.is_selected;
    item.width = props.imageElement.width * 72 * props.design.preview_scale;
    item.height = props.imageElement.height * 72 * props.design.preview_scale;
    item.guidesVisible = props.guidesVisible;
    return item;
  },

  endDrag(props, monitor, component) {
    const isDragging = false,
      isSelected = false;

    props.handleIsDragging(isDragging, isSelected);

    if (!monitor.didDrop()) {
      return;
    }
  },
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
  };
}

function calculatePosition(props) {
  let position = {};
  const scale = 72 * props.design.preview_scale;
  position.top = props.imageElement.top_position * scale;
  position.left = props.imageElement.left_position * scale;
  return position;
}

function getStyles(props) {
  const { isDragging } = props;

  const hideElement =
    isDragging || (props.imageElement.is_selected && props.isDraggingSelected);

  return {
    opacity: hideElement ? 0 : 1,
    height: hideElement ? 0 : "",
  };
}

class DraggableImageElement extends React.Component {
  state = {
    resizing: false,
  };

  componentDidMount() {
    this.props.connectDragPreview(getEmptyImage(), {
      captureDraggingState: true,
    });
  }

  handleIsResizing = (isResizing) => {
    this.setState({
      resizing: isResizing,
    });
  };

  render() {
    const { connectDragSource } = this.props;

    const element = (
      <div className="draggable-image" style={getStyles(this.props)}>
        <ImageElement
          index={this.props.index}
          layerId={this.props.layerId}
          imageElement={this.props.imageElement}
          itemType={ItemTypes.IMAGE}
          design={this.props.design}
          disableInteractivity={this.props.disableInteractivity}
          onShow2ndTip={this.props.onShow2ndTip}
          didShow2ndTip={this.props.didShow2ndTip}
          handleHide2ndTip={this.props.handleHide2ndTip}
          handleIsResizing={this.handleIsResizing}
          layer={this.props.layer}
        />
      </div>
    );

    return this.props.disableInteractivity || this.state.resizing
      ? element
      : connectDragSource(element);
  }
}

DraggableImageElement.propTypes = {
  layerId: PropTypes.number.isRequired,
  imageElement: PropTypes.object.isRequired,
  design: PropTypes.object.isRequired,
};
export default DragSource(
  ItemTypes.IMAGE,
  source,
  collect,
)(DraggableImageElement);
